import {toast} from 'react-toastify';
// import './Interceptor'
var ANum = [/۰/g, /۱/g, /۲/g, /۳/g, /٤/g, /٥/g, /٦/g, /۷/g, /۸/g, /۹/g];
var PNum = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
var EnNum = [/0/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g];

export function addCommas(x) {
    // return x.toString()
    if(typeof(x) !== 'undefined'){
        x = x.toString()
        return x.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    return x
    
}
export function removeCommas(x) {
    // return x.toString()
    if(typeof(x) !== 'undefined'){
        x = x.toString()
        return x.replace(/[^0-9]/gi, '')
    }
   
    return x
}
export function fixNumbers(str){
    str = str.toString()
    for(var i=0; i<10; i++)
      {
        str = str.replace(PNum[i], i).replace(EnNum[i], i);
        str = str.replace(ANum[i], i).replace(EnNum[i], i);
      }
    return str;
}

export default function MinimalStr(str, maxchar){
    if(str.length < maxchar){
        return str
    }else{
        return str.substring(0,maxchar) + '...'
    }
}

export function AppAlert(status, text){
    switch (status) {
        case 200:
            return toast.success(text)
        case 400: 
            return toast.warn(text);
        case 403: 
            return toast.warn('شما اجازه دسترسی به این اطلاعات را ندارید');
        case 401:
            return toast.error(text);
            
        case 500:
        case 405:
            if(text){
                return toast.error(text);
            }else{
                return toast.error('اشکال در سرور، لطفا با مدیر سیستم تماس بگیرید');
            }
            // return toast.info('اشکال در ارتباط با سامانه');
        case 404:
            return
        case 503:
            return toast.warn('خطای داخلی سیام');
        default:
            return 
            
    }
}